import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function pour fusionner les classes Tailwind sans conflits.
 * Pattern shadcn/ui standard.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
